import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about-me',
  templateUrl: './about-me.component.html',
  styleUrls: ['./about-me.component.scss']
})
export class AboutMeComponent implements OnInit {
  public currentStep: number
  public lastStep: number = 3
  public fName: string
  public lName: string
  public dob: Date
  public postCode: string

  sectionTitle = 'Tell us a bit about you'
  
  constructor(private router: Router) {
    this.currentStep = 1;
  }

  nextStep(){
    if(this.currentStep == this.lastStep){
      this.router.navigate(['/payment']);
    }
    this.currentStep++;
  }
  ngOnInit() {
  }

}
